export default __webpack_public_path__ + "static/media/win_Stage2.fd80500a.mp3";